export const isValidChange = (changedText, originalText) => {
		return !changedText || changedText === '' || changedText === originalText ? false : true ;
};
